import { render } from "./FeedbackPage.vue?vue&type=template&id=0855f7ae&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"

import "./FeedbackPage.vue?vue&type=style&index=0&id=0855f7ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0855f7ae"],['__file',"src/views/HistoricalData/FeedbackPage/FeedbackPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0855f7ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0855f7ae', __exports__)) {
    api.reload('0855f7ae', __exports__)
  }
  
  module.hot.accept("./FeedbackPage.vue?vue&type=template&id=0855f7ae&scoped=true", () => {
    api.rerender('0855f7ae', render)
  })

}


export default __exports__